module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAATpJREFUOE+Vkk0rBWEcxX8nIQuKtZcFCx/gxsYGiUi3lI18BaUsrKysLJWvcFfKgpLrpSwsRPkAksUtK6WUiOjo0dzbzDAz1383nfP85v+c84icsV0FviTNZtmUJdieAM4ifVzS+V/ePMAxMBUdqkqaaRpguwRcAfUfGChJuklDEhvYbgMGgR0gXCE+p8AKcC/poy7I9howDQwB/UBLXrDAJ1AD7oCTAHgCugsOZcmPATAJHAAd/4S8AfM/GdgOPe8B7U1C3oEFSYeNEG2XgV2gtQASAlyUtB986RYqwFIBoCJpudFC3Gz7KGokj5F4VOkNQj19BRvUJA382sB2J/CculaoOExPDBpeZZekl0QGtkeBy8j4CmwDW9H3OrAaq3pE0nUaMAxcACHdDUkPqXx6gU1gDhiTdBv0b56EYqlODGPlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/shoucang.png
// module id = h253
// module chunks = 2